import { AuthErrorCodes } from "firebase/auth";

export const authErrorMessages = {
  [AuthErrorCodes.USER_DELETED]:
    "Couldn't find an user for this email. Please ensure the right email or create new account",
  [AuthErrorCodes.INVALID_PASSWORD]:
    "You've entered wrong password. Please provide a valid password to continue",
  [AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER]:
    "Oops! Encountered some error while trying to login. Please try again in some time",
  [AuthErrorCodes.WEAK_PASSWORD]:
    "Your password is too weak. Please  use a stronger password to continue",
  [AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER]:
    "Oops! Encountered some error while trying to register. Please try again in some time",
  [AuthErrorCodes.EMAIL_EXISTS]:
    "This email is already in use. Please use a different email or login instead",
  [AuthErrorCodes.INVALID_EMAIL]:
    "Please provide a valid email address to continue",
};
